import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50caf954"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row g-0" }
const _hoisted_2 = { class: "col eq-object" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row g-0" }
const _hoisted_5 = { class: "col-12 col-lg align-self-center pt-4 pb-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-auto w-xs-0 height" }, null, -1))

import PageHeroContactPerson from '@/components/PhotovoltaikPage/PageHeroContactPerson.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageHero',
  props: {
  headline: String,
  content: String,
  buttonLabel: String,
},
  setup(__props) {

const { ioappConfig } = window;
const backgroundImage = `url(${ioappConfig.pluginUri}public/img/Hero.jpg)`;



return (_ctx: any,_cache: any) => {
  const _component_BaseSpacer = _resolveComponent("BaseSpacer")!

  return (_openBlock(), _createElementBlock("div", {
    class: "page-hero bg-primary",
    style: _normalizeStyle({ backgroundImage: backgroundImage })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h1", null, _toDisplayString(__props.headline), 1),
              _createVNode(_component_BaseSpacer, { size: "l" }),
              _createElementVNode("p", null, _toDisplayString(__props.content), 1),
              _createVNode(_component_BaseSpacer, { size: "l" }),
              _renderSlot(_ctx.$slots, "button")
            ]),
            _createVNode(PageHeroContactPerson),
            _hoisted_6
          ])
        ])
      ])
    ])
  ], 4))
}
}

})